import React from 'react';

import { css } from '@emotion/core';
import { Flex, Text } from '@rebass/emotion';
import Colors from '@theme/colors';

interface FormCheckbox {
  name: string;
  value: boolean | null;
  onChange: (e: { target: { value: string; checked: string; id: string } }) => void;
  id: string;
  label: string;
}

const selectedStyle = css`
  :after {
    background: ${Colors.science37};
    content: '';
    display: inline-block;
    height: 10px;
    left: 7px;
    width: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(12px, -50%);
    -ms-transform: translate(12px, -50%);
    transform: translate(12px, -50%);
  }
`;

const FormCheckbox = ({ name, value, onChange, id, label }: FormCheckbox) => {
  return (
    <Flex
      mb={[2]}
      width={[1]}
      css={css`
        border-style: solid;
        border-width: 2px;
        border-color: ${value ? Colors.science37 : Colors.transparent};
        background-color: ${value ? Colors.science37Light5 : Colors.transparent};
        border-radius: 4px;
      `}
    >
      <input
        name={name}
        type="checkbox"
        id={id}
        value={value ? value.toString() : ''} // could be something else for output?
        checked={Boolean(value)}
        onChange={onChange}
        css={css`
          height: 1px;
          opacity: 0;
          width: 1px;
          margin: 0;
        `}
      />
      <label
        css={css`
          position: relative;
          width: 100%;
          min-height: 50px;
          height: auto;
          padding: 5px 0;
          border-style: solid;
          border-color: ${value ? Colors.transparent : Colors.commonGray1};
          border-width: 1px;
          border-radius: 4px;
          :before {
            border: 2px solid ${value && value ? Colors.science37 : Colors.neutral75};
            content: '';
            display: inline-block;
            height: 20px;
            width: 20px;
            color: ${Colors.neutral75};
            position: absolute;
            top: 50%;
            -webkit-transform: translate(12px, -50%);
            -ms-transform: translate(12px, -50%);
            transform: translate(12px, -50%);
          }
          ${value && selectedStyle}
        `}
        htmlFor={id}
      >
        <Text
          fontSize={[2]}
          css={css`
            display: flex;
            margin-left: 22px;
            padding-left: 24px;
            align-items: center;
            height: 100%;
          `}
        >
          {label}
        </Text>
      </label>
    </Flex>
  );
};

export { FormCheckbox };
